import request from "@/common/request";
import router from "@/router";
export function operateLogs(desc:any) {
  let params = {
    router:router.currentRoute?.value?.fullPath,
    desc:desc
  }
  request.post('/api/logs/operate', params)
}